import { type ReactNode, type RefObject } from 'react';

import { Text } from '../../../../components/ToolkitV2/Text/Text';

import { Header, HeaderIcon } from './MakeModelKeywordSearchModal.styled';
import { AlwaysRenderedModal } from './AlwaysRenderedModal';

type MakeModelKeywordSearchModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  children: ReactNode;
  contentRef: RefObject<HTMLDivElement>;
  returnFocusTo?: RefObject<HTMLElement | null>;
};

export const MakeModelKeywordSearchModal = (
  props: MakeModelKeywordSearchModalProps,
) => {
  const {
    isOpen,
    onRequestClose,
    children,
    contentRef,
    returnFocusTo,
    ...rest
  } = props;

  return (
    <AlwaysRenderedModal
      isOpen={isOpen}
      contentLabel="Make Model Keyword Search Modal"
      onRequestClose={onRequestClose}
      contentRef={contentRef}
      returnFocusTo={returnFocusTo}
      {...rest}
    >
      <Header onClick={onRequestClose} aria-label="Close modal">
        <Text size="M16" weight="bold" color="GREY_DARKER">
          Make & model
        </Text>
        <HeaderIcon />
      </Header>
      {children}
    </AlwaysRenderedModal>
  );
};
